<template>
  <div>
    <div class="header-placeholder" v-if="isSticky"></div>
    <div class="header" :class="{ 'sticky': isSticky }">
      <div class="logo" @click="goToHome" style="cursor: pointer;">
        <img src="../assets/images/logo.png" alt="AiBZ Logo">
      </div>
      <div class="user-info" v-if="isLoggedIn">
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="user-dropdown">
            <i class="el-icon-user"></i>
            {{ userName }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="history">历史记录</el-dropdown-item>
            <el-dropdown-item command="users" v-if="isAdmin">用户审核</el-dropdown-item>
            <el-dropdown-item command="changePassword">修改密码</el-dropdown-item>
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    
    <!-- 修改密码弹窗 -->
    <el-dialog
      title="修改密码"
      :visible.sync="passwordDialogVisible"
      width="400px"
      @close="closePasswordDialog">
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="100px">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input v-model="passwordForm.oldPassword" type="password" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="passwordForm.newPassword" type="password" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input v-model="passwordForm.confirmPassword" type="password" show-password></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closePasswordDialog">取 消</el-button>
        <el-button type="primary" @click="submitPasswordForm" :loading="passwordLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { isAdmin } from '@/utils/auth'
import { post } from '@/utils/fetch'

export default {
  name: 'AppHeader',
  data() {
    return {
      userName: '',
      isLoggedIn: false,
      isAdmin: false,
      isSticky: false,
      passwordDialogVisible: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        oldPassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        confirmPassword: [{ required: true, message: '请确认新密码', trigger: 'blur' }]
      },
      passwordLoading: false
    };
  },
  created() {
    this.getUserInfo();
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isSticky = window.pageYOffset > 0;
      // 触发事件通知父组件
      // this.$parent.isHeaderSticky = this.isSticky;
    },
    getUserInfo() {
      const userInfo = localStorage.getItem('userInfo');
      if (userInfo) {
        const parsedInfo = JSON.parse(userInfo);
        this.userName = parsedInfo.name || parsedInfo.email || '用户';
        this.isLoggedIn = true;
        this.isAdmin = isAdmin();
      } else {
        this.isLoggedIn = false;
        this.isAdmin = false;
      }
    },
    handleCommand(command) {
      if (command === 'logout') {
        this.logout();
      } else if (command === 'history') {
        this.goToHistory();
      } else if (command === 'users') {
        this.goToUserList();
      } else if (command === 'changePassword') {
        this.showPasswordDialog();
      }
    },
    goToHistory() {
      this.$router.push('/history').catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
    goToUserList() {
      this.$router.push('/users').catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
    logout() {
      // 清除本地存储中的用户信息
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
      
      // 重定向到登录页面
      this.$router.replace('/login').catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
    goToHome() {
      this.$router.push('/').catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
    showPasswordDialog() {
      this.passwordDialogVisible = true;
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      };
    },
    closePasswordDialog() {
      this.passwordDialogVisible = false;
    },
    submitPasswordForm() {
      this.$refs.passwordForm.validate(valid => {
        if (!valid) {
          return;
        }
        
        if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
          this.$message.error('两次输入的新密码不一致');
          return;
        }
        
        this.passwordLoading = true;
        post('/api/user/change-password', {
          oldPassword: this.passwordForm.oldPassword,
          newPassword: this.passwordForm.newPassword
        }).then(() => {
          this.$message.success('密码修改成功，请重新登录');
          this.logout()
          this.passwordDialogVisible = false;
        }).catch(error => {
          this.$message.error(error.message || '密码修改失败');
        }).finally(() => {
          this.passwordLoading = false;
        });
      });
    }
  }
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  width: 100%;
  padding: 0 120px;
  box-sizing: border-box;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  background-color: #fff;
  z-index: 1000;
  transition: all 0.3s ease;
}

.header-placeholder {
  height: 70px;
  width: 100%;
}

.sticky {
  position: fixed;
  top: 0;
  left: 0;
  box-shadow: 0 2px 10px rgba(0, 21, 41, 0.15);
  animation: slideDown 0.3s;
}

@keyframes slideDown {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}

.logo {
  display: flex;
  align-items: center;
}

.logo img {
  height: 60px;
  width: auto;
  object-fit: contain;
  margin-right: 10px;
}

.logo-text {
  font-size: 20px;
  font-weight: bold;
  color: #7e57c2;
}

.user-info {
  display: flex;
  align-items: center;
}

.user-dropdown {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #606266;
  font-size: 14px;
}

.user-dropdown:hover {
  color: #7e57c2;
}

.el-icon-user {
  margin-right: 5px;
  font-size: 16px;
}
</style> 